// -----------------------------------------------------------------------------
// <copyright file="no-value.pipe.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noValue',
  standalone: false,
})
export class NoValuePipe implements PipeTransform {
  transform(value: string | null | undefined, args?: string): string {
    if (args && args == 'allowZero' && value == '0') {
      return value;
    }
    return value || '---';
  }
}
